import { render, staticRenderFns } from "./ClosingCta.vue?vue&type=template&id=2b36e3ee&scoped=true&"
import script from "./ClosingCta.vue?vue&type=script&lang=js&"
export * from "./ClosingCta.vue?vue&type=script&lang=js&"
import style0 from "./ClosingCta.vue?vue&type=style&index=0&id=2b36e3ee&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36e3ee",
  null
  
)

export default component.exports